import { Box, Button, Divider, Grid, Icon, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { GetLogedInMembers } from "../../api/hooks";
import { IMemberLoginHistory } from "../../api/types";
import MainCard from "components/MainCard";
import { BarChartOutlined } from "@ant-design/icons";
import FormLoader from "components/Containers/FormLoader";
import LoginHistoryChart from "./LoginHistoryChart";

const LoginHistoryStatistics = () => {
  const [filterModel, setFilterModel] = useState({
    filter: {
      fromDate: null,
      toDate: null,
    },
  });

  const [data, setData] = useState<IMemberLoginHistory>();

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      fromDate: null,
      toDate: null,
    },
  });

  const onSubmit = handleSubmit((filter) => {
    setFilterModel({
      filter: {
        fromDate: filter.fromDate ? filter.fromDate : null,
        toDate: filter.toDate ? filter.toDate : null,
      },
    });
  });

  const loginHistoryQuery = GetLogedInMembers(filterModel);

  useEffect(() => {
    if (loginHistoryQuery.data?.status === 200) {
      setData(loginHistoryQuery?.data?.apiData);
    }
  }, [loginHistoryQuery.data]);

  useEffect(() => {
    loginHistoryQuery.refetch();
  }, [filterModel]);

  const handleClear = () => {
    setFilterModel((prev) => ({
      ...prev,
      filter: {
        fromDate: null,
        toDate: null,
      },
    }));
    reset();
  };

  return (
    <>
      <MainCard sx={{ my: 1 }}>
        <Typography variant="h3">
          <Icon sx={{ marginRight: "5px" }}>
            <BarChartOutlined />
          </Icon>
          Active Members
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Box component="form" noValidate sx={{ my: 3 }} onSubmit={onSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={6} md={6} lg={4}>
              <Controller
                name="fromDate"
                control={control}
                render={({
                  field: { value, onChange },
                  fieldState: { error },
                }) => (
                  <DatePicker
                    sx={{ width: "100%" }}
                    label="From Date"
                    format="DD-MM-YYYY"
                    value={value ? dayjs(value) : null}
                    onChange={onChange}
                    slotProps={{
                      textField: {
                        error: !!error,
                        helperText: error?.message,
                        fullWidth: false,
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} md={6} lg={4}>
              <Controller
                name="toDate"
                control={control}
                render={({
                  field: { value, onChange },
                  fieldState: { error },
                }) => (
                  <DatePicker
                    sx={{ width: "100%" }}
                    label="To Date"
                    format="DD-MM-YYYY"
                    value={value ? dayjs(value) : null}
                    onChange={onChange}
                    slotProps={{
                      textField: {
                        error: !!error,
                        helperText: error?.message,
                        fullWidth: false,
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid
              item
              display={"flex"}
              alignItems={"center"}
              xs={6}
              md={4}
              lg={3}
            >
              <Button type="submit" variant="contained">
                Show
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                sx={{ ml: 1 }}
                onClick={handleClear}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Grid container spacing={2.5}>
          <Grid item sm={12} md={12} xs={12}>
            {loginHistoryQuery.isFetching ? (
              <FormLoader />
            ) : (
              <LoginHistoryChart data={data?.data || []} />
            )}
          </Grid>
        </Grid>
      </MainCard>
    </>
  );
};

export default LoginHistoryStatistics;
